import * as angular from 'angular';
export class FrequentFlyersCompaniesService {
    constructor (
        private CommonsGenericProxy: CommonsGenericProxy,
        private MmBAppConstants: any,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private localStorageService: angular.local.storage.ILocalStorageService
    ) {}

    getFrequentFlyersCompanies = () => {


        return new Promise((resolve, reject) => {
            const frequentFlyersCompanies = this.localStorageService.get('frequentFlyersCompanies');

            if (frequentFlyersCompanies === null) {
                this.CommonsGenericProxy.getGeneric(this.MmBAppConstants.companiesServiceURI).then(
                    (response) => {
                        this.localStorageService.set('frequentFlyersCompanies', response.data);
                        resolve(response.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });
            } else {
                resolve(frequentFlyersCompanies);
            }
        });
    };
}
FrequentFlyersCompaniesService.$inject = ['CommonsGenericProxy', 'MmBAppConstants', 'CommonsNewHttpUtilsErrorService', 'localStorageService'];
try {
    const mod = angular.module('ib-MmB-services-module');
    mod.service(
        'FrequentFlyersCompaniesService',
        FrequentFlyersCompaniesService
    );
} catch (error) {
    const mod = angular.module('ib-MmB-services-module', []);
    mod.service(
        'FrequentFlyersCompaniesService',
        FrequentFlyersCompaniesService
    );
}
